import React from "react";
import { Web3ReactProvider } from '@web3-react/core';
import {IntlProvider} from 'react-intl';
import { ToastProvider } from 'react-toast-notifications';
import { Redirect } from "react-router-dom";

import "./../styles/global.scss";
import IndexPage from "./index";
import PrivateMintPage from "./private-mint";
import PublicMintPage from "./public-mint";
import AlphaWhalePage from "./alphawhale";
import WalletPage from "./wallet";
import DepositPage from "./deposit";
import AccountCompletePage from "./account-complete";
import AdminPage from "./admin";
import { Switch, Route, Router } from "./../util/router.js";
import NotFoundPage from "./not-found.js";
import "./../util/analytics.js";
import { QueryClientProvider } from "./../util/db.js";
import { getLibrary } from "./../util/web3React";
import MetamaskProvider from '../providers/MetamaskProvider';

import NavbarCustom from "../components/NavbarCustom";
import Footer from "./../components/Footer";
import logoWhite from "../images/whaletogether-mock.jpg";

const REACT_APP_PRESALE = process.env.REACT_APP_PRESALE;

function App(props) {
  const companyName = 'WhaleTogether';
  return (
    <IntlProvider locale="en-US">
      <ToastProvider placement="bottom-left">
        <Web3ReactProvider getLibrary={getLibrary}>
          <MetamaskProvider>
            <QueryClientProvider>
              <Router>
                <NavbarCustom
                  bg="black"
                  variant="dark"
                  expand="md"
                  logo={logoWhite}
                />
                <Switch>
                  {/* <Route exact path="/" component={IndexPage} /> */}
                  {REACT_APP_PRESALE === 'true' ? (
                    <Route exact path="/" component={PrivateMintPage} />
                  ) : (
                    <Route exact path="/" component={PublicMintPage} />
                  )}
                  <Route exact path="/">
                    <Redirect to="/wallet" />
                  </Route>
                  <Route exact path="/alphies/:id" component={AlphaWhalePage} />
                  <Route exact path="/wallet" component={WalletPage} />
                  <Route exact path="/admin" component={AdminPage} />
                  <Route exact path="/account/complete" component={AccountCompletePage} />
                  <Route exact path="/deposit" component={DepositPage} />
                  <Route component={NotFoundPage} />
                </Switch>
                <Footer
                  bg="white"
                  textColor="dark"
                  size="md"
                  bgImage=""
                  bgImageOpacity={1}
                  copyright={`© ${new Date().getFullYear()} ${companyName}`}
                  logo={logoWhite}
                />
              </Router>
            </QueryClientProvider>
          </MetamaskProvider>
        </Web3ReactProvider>
      </ToastProvider>
    </IntlProvider>
  );
}

export default App;
